import { createDefaultListState, DunningLevel, makeSortedList } from '@aston/foundation';

import { CreateDebtorPortalRequest } from '../models/request-create.model';
import { PortalRequestApi } from '../models/request.api';
import { PortalRequest } from '../models/request.model';

export function mapToCreateDebtorPortalRequest(data: Partial<CreateDebtorPortalRequest>): CreateDebtorPortalRequest {
	const result: Partial<CreateDebtorPortalRequest> = {
		dunningLevel: data.dunningLevel,
		accountingDocumentIds: data.accountingDocumentIds || [],
	}

	if (result.dunningLevel === DunningLevel.LTG) {
		result.content = data.content;
		result.email = data.email;
	}

	if (result.dunningLevel === DunningLevel.PAA) {
		result.paymentDate = data.paymentDate;
		result.email = data.email;
	}

	if (result.dunningLevel === DunningLevel.PPA) {
		result.content = data.content;
		result.email = data.email;
	}

	return result as CreateDebtorPortalRequest;
}

export function mapToDebtorPortalRequest(data: PortalRequestApi): PortalRequest {
	const ads = data.accountingDocuments || [];
	return {
		...data,
		accountingDocumentsExpandOpened: false,
		totalAmount: ads.reduce((acc, ad) => acc + ad.balanceInvoicing, 0),
		accountingDocumentsList: makeSortedList({ items: ads }, createDefaultListState()),
	}
}